import { contractApi } from "@/axios";
export function getReportDataPage(params, data, type) {
    return contractApi({
        url: '/report-data/page/' + type,
        method: 'post',
        params: params,
        data: data
    })
}
export function downloadReportData(hexCode,type) {
    return contractApi({
        url: `/report-data/download/${hexCode}/${type}`,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}